import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '@/hooks/useAppSelector';

import { fetchAudit } from '../services/actions';
import { selectAuditApi, selectAuditData } from '../services/selectors';

export const useFetchAudit = () => {
    const api = useAppSelector(selectAuditApi);
    const data = useAppSelector(selectAuditData);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchAudit());
    }, [dispatch]);

    return {
        showLoader: api.inProgress,
        data,
    };
};
